import { store } from "../../index";
import { loadUserRole, loadRolePermissions, loadUserPermissions } from "../helpers/HelperFunctions";

/**
 * 
 * @param {String} permission - check if user has this specific permission
 */
const hasPermission = (permission = null) => {
	let response = false;
	const user = store.getState().userLoginData && store.getState().userLoginData.user;
	const rolePermissions = user && loadRolePermissions(user.roles);
	if(rolePermissions && Array.isArray(rolePermissions)) {
		rolePermissions.forEach(item => {
			Object.keys(item).forEach((key) => {
				if(key === permission && item[key] === true) { response = true; }
			});
		});
	}
	return response;
};

/**
 * 
 * @param {number} int - role id
 */
const hasRole = (roleId) => {
	const user = store.getState().userLoginData && store.getState().userLoginData.user;
	const requestedRole = (user && user.roles && user.roles.find((role)=> role.id === roleId));
	if(requestedRole && requestedRole.id === roleId) return true;
	return false;
};

/**
 * 
 * @param {Object} user - user object data
 */
const isSuperAdmin = (user) => {
	if(!user) { return false; }
	const role = loadUserRole(user.roles);
	return role === 1;
};

export { hasPermission, hasRole, isSuperAdmin };  // eslint-disable-line  import/prefer-default-export


// WEBPACK FOOTER //
// ./src/components/helpers/Permissions.js